import { Box, Button, Stack, Divider } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { NAVIGATION } from "../../../../../../locales/components/namespaces";
import { useLoginOverlay } from "../../../../../auth/loginOverlay/loginOverlayProvider";
import {useState} from "react";

const AccountPopupNotLoggedIn = ({ onClose,onLoginClick,onSignUp }) => {
  const theme = useTheme();
  const { t } = useTranslation(NAVIGATION);

  return (
    <Stack spacing={0}>
      {/* Content */}
      <Box
        sx={{
          px: "20px",
          py: "16px",
        }}
      >
        <Box
          component="p"
          sx={{
            margin: 0,
            fontSize: "13px",
            fontWeight: 400,
            lineHeight: "120%",
            fontFamily: "'Roboto Condensed', Arial, sans-serif",
            color: theme.palette.text.primary,
          }}
        >
          {t("account_popup_login_description")}
        </Box>
      </Box>

      {/* Actions */}
      <Stack
        spacing={0}
        sx={{
          px: "20px",
        }}
      >
        <Button
          fullWidth
          variant="outlined"
          sx={{
            borderRadius: "24px",
            borderColor: theme.palette.primary.main,
            color: theme.palette.primary.main,
            height: "35px",
            fontSize: "12px",
            fontWeight: 900,
            textTransform: "uppercase",
            letterSpacing: "0.5px",
          }}
          onClick={() => {
              if (typeof onLoginClick === "function") onLoginClick();
              else onClose();
          }}

        >
          {t("account_popup_login_button")}
          <NavigateNextIcon sx={{ ml: 1, fontSize: 18 }} />
        </Button>

        <Divider sx={{ my: "12px" }} />

        <Box
          component="p"
          sx={{
            margin: 0,
            fontSize: "13px",
            fontWeight: 400,
            lineHeight: "120%",
            fontFamily: "'Roboto Condensed', Arial, sans-serif",
            color: theme.palette.text.primary,
            mb: "12px",
          }}
        >
          {t("account_popup_first_time_question")}
        </Box>

        <Button
          fullWidth
          variant="outlined"
          sx={{
            borderRadius: "24px",
            borderColor: theme.palette.primary.main,
            color: theme.palette.primary.main,
            height: "35px",
            fontSize: "12px",
            fontWeight: 900,
            textTransform: "uppercase",
            letterSpacing: "0.5px",
            mb: "15px",
          }}
          onClick={() => {
              if (typeof onSignUp === "function") onSignUp();
              else onClose();
          }}
        >
          {t("account_popup_signup_button")}
          <NavigateNextIcon sx={{ ml: 1, fontSize: 18 }} />
        </Button>
      </Stack>
    </Stack>
  );
};

export default AccountPopupNotLoggedIn;
